import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { PATIENT_CODE } from '../form-branch'

const OpShowPatient = () => {
    const { t } = useTranslation()
    const optionShowPatient = [
        {
            name: t('BRANCH.TAB.SENTTING.SHOW_CN'), value: PATIENT_CODE.CN,
            component: <ShowPatient showType='CN' />,
        },
        {
            name: t('BRANCH.TAB.SENTTING.SHOW_PT'), value: PATIENT_CODE.PT,
            component: <ShowPatient showType='PT' />,
        },
        {
            name: t('BRANCH.TAB.SENTTING.SHOW_SN'), value: PATIENT_CODE.SN,
            component: <ShowPatient showType='SN' />,
        }
    ]
    return (optionShowPatient)
}

export default OpShowPatient

interface ShowPatientProps {
    showType: 'CN' | 'PT' | 'SN'
}
const ShowPatient = (props: ShowPatientProps) => {
    const { showType } = props
    const { t } = useTranslation()

    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box marginBottom='16px'>
                <Typography fontSize={'20px'} fontWeight={'500'} marginBottom='8px'>
                    {t('BRANCH.TAB.SENTTING.SHOWPATIENT')}{t('BRANCH.TAB.SENTTING.SYSTEM')}
                </Typography>
                <Typography fontWeight={'400'} paddingLeft='16px' color='#5A5A5A'>
                    {t('BRANCH.TAB.SENTTING.SUB_TITLE')}
                </Typography>
            </Box>

            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.TAB.SENTTING.SHOW_${showType}`)}
                </Typography>
                <Typography fontWeight={'400'} paddingLeft='16px' color='#5A5A5A'>
                    {t(`BRANCH.TAB.SENTTING.SUB_SHOW_${showType}`)}
                </Typography>
            </Box>

            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.TAB.SENTTING.EXAMPLE`)}
                </Typography>
                <Box marginTop="8px" padding="16px" bgcolor={'#ffffff'} fontStyle="italic">
                    <Typography fontWeight={'400'} paddingLeft='20px' color='#5A5A5A'>
                        {t(`BRANCH.TAB.SENTTING.${showType}_EXAMPLE`)}
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}